/* esm.sh - @use-gesture/core@10.3.1/types */
export * from "/*@use-gesture/core@10.3.1/esnext/types.mjs";
export { default } from "/*@use-gesture/core@10.3.1/esnext/types.mjs";
